import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { JkReportComponent } from './jkReport';
import { PageKind } from 'jk-service';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ''
})
export class JkBatchComponent extends JkReportComponent {

  constructor() {
    super();
    this.pageKind = PageKind.batch;
  }
  override ngOnInit() {
    super.ngOnInit();
    this.getLookup();
  }

}
